module.exports = __webpack_public_path__ + "img/奖品-拍立得.521f11d4.png";